import React from 'react';
import { useAppContext } from '../context/AppContext';
import EarningsTab from '../components/EarningsTab';
import DecryptedText from '../components/DecryptedText';

/**
 * Earnings Page
 * Shows participant earnings and payout history
 */
const Earnings: React.FC = () => {
  const { isLoading } = useAppContext();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-pink-600">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p className="text-white font-space">Loading earnings...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-transparent relative overflow-hidden sm:pt-24 pb-12">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute top-20 left-20 w-32 h-32 bg-white bg-opacity-20 rounded-full blur-xl"></div>
        <div className="absolute top-40 right-32 w-24 h-24 bg-white bg-opacity-15 rounded-full blur-lg"></div>
        <div className="absolute bottom-32 left-16 w-20 h-20 bg-white bg-opacity-25 rounded-full blur-lg"></div>
        <div className="absolute bottom-20 right-20 w-28 h-28 bg-white bg-opacity-20 rounded-full blur-xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="mb-8">
          <DecryptedText
            text="My Earnings"
            animateOn="view"
            revealDirection="start"
            speed={100}
            sequential={true}
            className="text-black text-3xl md:text-3xl font-bold text-left"
          />
          <p className="text-gray-600 mt-1">Track your bounty winnings and payout history.</p>
        </div>

        {/* Earnings Content */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/50 overflow-hidden p-6">
          <EarningsTab />
        </div>
      </div>
    </div>
  );
};

export default Earnings;
